import { MaybeNull } from 'interfaces/index'
import { UserDTO, UserProfileFormDTO } from 'interfaces/users/users'

export const getUserProfileFormValues = ({ user }: { user: MaybeNull<UserDTO> }): UserProfileFormDTO => ({
  firstName: user?.firstName || '',
  lastName: user?.lastName || '',
  email: user?.email || '',
})
